<ssc-contact-overlay
  *ngIf="showContactButton"
  (overlayClosed)="showContactOverlay = false"
  [showOverlay]="showContactOverlay"
>
  <visana-lib-button
    (click)="showContactOverlay = true"
    buttonSize="mediumtight"
    iconName="support"
    iconPosition="left"
    iconSize="20"
    variant="violet"
    data-analytics="footer_contact"
    >{{ 'FOOTER.CONTACT' | translate }}
  </visana-lib-button>
</ssc-contact-overlay>
